import { lazy } from 'react';
import { GarageGate } from '../lib/gate.js';

// Écran chargé à la demande : le portail client et la connexion n'en téléchargent pas le code.
const BaseScreen = lazy(() => import('../screens/BaseScreen.js'));

/** Base garage (02/10/2026) : annuaire des clients et des véhicules du garage, route `/base`. */
export default function BasePage() {
  return (
    <GarageGate>
      <BaseScreen />
    </GarageGate>
  );
}
